import {
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  useIonActionSheet,
} from "@ionic/react";
import { cloudDownloadOutline, trash } from "ionicons/icons";
import { useTranslation } from "react-i18next";

const SpikeGenPopover: React.FC<{
  imageLength: number;
  onHide: () => void;
  handleDeleteAllImages: () => void;
  handelDownloadAllImages: () => void;
}> = ({
  imageLength,
  onHide,
  handleDeleteAllImages,
  handelDownloadAllImages,
}) => {
  const { t } = useTranslation();
  const [present, dismiss] = useIonActionSheet();
  return (
    <IonList>
      <IonListHeader>{t(`Actions`)}</IonListHeader>
      <IonItem
        button
        detail={false}
        disabled={imageLength === 0}
        onClick={handelDownloadAllImages}
      >
        <IonLabel>{t(`Download`)}</IonLabel>
        <IonIcon
          color="teriary"
          slot="end"
          icon={cloudDownloadOutline}
          size="small"
        />
      </IonItem>
      <div className="py-1 bg-gray-400/10" />
      <IonItem
        button
        detail={false}
        disabled={imageLength === 0}
        onClick={() =>
          present({
            buttons: [
              {
                text: "Delete",
                role: "destructive",
                handler: handleDeleteAllImages,
              },
              { text: "Cancel", handler: onHide },
            ],
            header: "Are you sure you want to delete all generated images?",
          })
        }
      >
        <IonLabel color="danger">{t(`Delete...`)}</IonLabel>
        <IonIcon color="danger" slot="end" icon={trash} size="small" />
      </IonItem>
      {/* <IonItem lines="none" detail={false} button onClick={onHide}>
      Close
    </IonItem> */}
    </IonList>
  );
};
export default SpikeGenPopover;
